/* ==========================================================================
   Oh!My Snacks · Gift boxes — os cartões da página
   --------------------------------------------------------------------------
   Três coisas: escolher o tamanho, escolher quantas, e juntar ao carrinho.

   Não é o `oms-loja-nova.js`, e é de propósito: esse vive da grelha da loja
   (filtros, «ver mais», um contador por snack) e aqui há seis cartões, cada um com
   três variantes. O que se herda é o contrato com o resto do site:
   · a rota vem do Liquid (`routes.cart_add_url`), com o prefixo de mercado. Um
     `/cart/add.js` escrito à mão mandava a pessoa para o carrinho inglês;
   · depois de a Shopify aceitar, avisa a gaveta com `oms:carrinho:entrou`, que é o
     que a abre ao lado (`oms-carrinho.js`, decisão do Júlio a 2026-09-27);
   · o número do saco não é daqui: o `oms-ohm.js` vê o pedido a `/cart/add` e relê o
     carrinho sozinho.
   Um esgotado volta com `{status, description}`, e a descrição já vem traduzida
   pela Shopify: é ela que aparece no cartão.
   ========================================================================== */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-gb-lista]');
  if (!raiz) return;
  var T = {};
  try { T = JSON.parse(raiz.querySelector('[data-gb-textos]').textContent); } catch (e) { return; }

  function quantos(ficha) {
    return Math.min(99, Math.max(1, Number(ficha.dataset.entrar) || 1));
  }

  function mostrar(ficha) {
    var o = ficha.querySelector('output');
    if (o) o.value = quantos(ficha);
  }

  function aviso(ficha, texto) {
    var p = ficha.querySelector('.gb-aviso');
    if (!p) return;
    p.textContent = texto || '';
    p.hidden = !texto;
  }

  function escolher(ficha, bt) {
    ficha.querySelectorAll('[data-gb-tamanho]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === bt ? 'true' : 'false');
    });
    ficha.dataset.variante = bt.dataset.variante;
    var valor = ficha.querySelector('[data-gb-valor]');
    if (valor) valor.textContent = bt.dataset.valor;
    aviso(ficha, '');
  }

  function juntar(ficha, bt) {
    if (bt.getAttribute('aria-busy') === 'true') return;
    var variante = Number(ficha.dataset.variante);
    if (!variante) return;
    bt.setAttribute('aria-busy', 'true');
    aviso(ficha, '');
    fetch(T.rota_add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variante, quantity: quantos(ficha) }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || (res.d && res.d.status)) throw new Error((res.d && res.d.description) || '');
        ficha.dataset.entrar = 1;
        mostrar(ficha);
        document.dispatchEvent(new CustomEvent('oms:carrinho:entrou', {
          detail: { origem: 'gift-box', variante: variante }
        }));
      })
      .catch(function (e) { aviso(ficha, e.message); })
      .finally(function () { bt.removeAttribute('aria-busy'); });
  }

  raiz.addEventListener('click', function (e) {
    var ficha = e.target.closest('[data-gb-ficha]');
    if (!ficha) return;
    var tamanho = e.target.closest('[data-gb-tamanho]');
    if (tamanho) { if (!tamanho.disabled) escolher(ficha, tamanho); return; }
    if (e.target.closest('[data-mais]')) { ficha.dataset.entrar = quantos(ficha) + 1; mostrar(ficha); return; }
    if (e.target.closest('[data-menos]')) { ficha.dataset.entrar = quantos(ficha) - 1; mostrar(ficha); return; }
    var bt = e.target.closest('[data-juntar]');
    if (bt) { e.preventDefault(); juntar(ficha, bt); }
  });
})();
